<header class="app-header" *ngIf="isAuthenticated">
    <div class="header-left">
        <div class="header-brand">
            <div class="header-logo" aria-label="Tradingtagebuch">
                <span class="header-logo__rk">RK</span>
                <span class="header-logo__text">Trading</span>
            </div>
        </div>
    </div>
    <div class="header-stage" aria-label="Aktuelle Stufe">
        <div
                class="header-stage__badge header-stage__badge--stage"
                title="Deine Stufen Erfahrung im Trading"
                aria-label="Deine Stufen Erfahrung im Trading"
        >
            {{ stageNumber }}
        </div>
        <div
                class="header-stage__badge header-stage__badge--trades"
                title="Gesamt Trades"
                aria-label="Gesamt Trades"
        >
            <span class="badge-icon" *ngIf="totalTradesBadgeIcon()">{{ totalTradesBadgeIcon() }}</span>
            <span class="badge-count">{{ totalTradesCount }}</span>
        </div>

        <div
                class="header-stage__badge"
                [ngClass]="openPositionBadgeClass()"
                title="Offene Positionen"
                aria-label="Offene Positionen"
        >
            {{ openPositionCount }} 
        </div>
        <div
                class="header-stage__badge"
                [class.header-stage__badge--ok]="lossStreak === 0"
                [class.header-stage__badge--alert]="lossStreak > 0"
                title="Deine Anzahl fehlerhafter Trades hintereinander"
                aria-label="Deine Anzahl fehlerhafter Trades hintereinander"
        >
            {{ lossStreak }}
        </div>
    </div>
    <button type="button" class="nav-toggle" (click)="toggleMenu()" aria-label="Menü öffnen" title="Menü">☰</button>
    <nav class="nav-links" [class.nav-links--open]="menuOpen">
        <div class="nav-links__badges">
            <div class="header-stage__badge header-stage__badge--stage" aria-label="Aktuelle Stufe">{{ stageNumber }}</div>
            <div class="header-stage__badge header-stage__badge--trades" aria-label="Gesamt Trades">
                <span class="badge-icon" *ngIf="totalTradesBadgeIcon()">{{ totalTradesBadgeIcon() }}</span>
                <span class="badge-count">{{ totalTradesCount }}</span>
            </div>
            <div class="header-stage__badge" [ngClass]="openPositionBadgeClass()" aria-label="Offene Positionen">{{ openPositionCount }}</div>
            <div class="header-stage__badge" [class.header-stage__badge--ok]="lossStreak === 0" [class.header-stage__badge--alert]="lossStreak > 0" aria-label="Verlusttrades">{{ lossStreak }}</div>
        </div>
        <button type="button" class="refresh-button" aria-label="Seite neu laden" title="Neu laden" (click)="location.reload()">⟳</button>
        <a routerLink="/journal" routerLinkActive="active" (click)="closeMenu()">Tradingtagebuch</a>
        <a routerLink="/tagebuch" routerLinkActive="active" (click)="closeMenu()">Tagebuch</a>
        <div class="nav-admin">
            <span class="nav-admin__label">Administration</span>
            <div class="nav-admin__menu">
                <a routerLink="/risiko" routerLinkActive="active" (click)="closeMenu()">Risiko Money Management</a>
                <a routerLink="/statistik" routerLinkActive="active" (click)="closeMenu()">Auswertung</a>
                <a routerLink="/trades-tracker" routerLinkActive="active" (click)="closeMenu()">Meine Trades Tracker</a>
                <a routerLink="/analysen" routerLinkActive="active" (click)="closeMenu()">Analysen</a>
                <a routerLink="/konfiguration" routerLinkActive="active" (click)="closeMenu()">Konfiguration</a>
            </div>
        </div>
        <a href="#" class="nav-links__logout" (click)="$event.preventDefault(); logout()">Abmelden</a>
        <div class="header-stage__timer nav-links__timer" aria-label="Sessiondauer">
            <span class="header-stage__timer-label">Session</span>
            <span class="header-stage__timer-value">{{ sessionRemainingLabel }}</span>
        </div>
    </nav>
    <div class="nav-backdrop" *ngIf="menuOpen" (click)="closeMenu()"></div>
</header>
<main class="app-content">
    <router-outlet></router-outlet>
</main>
